const WITHAWAIT = true;
const ISFROMPAYMENTMODAL = true;

export default {
    WITHAWAIT,
    ISFROMPAYMENTMODAL,
    data() {
        return {
            joinInvoiceId: null,
            isFromPaymentModal: null,
            allowIntervalTriggering: false,
            feedbackReceived: false,
            intervalId: null
        };
    },
    mounted() {
        this.$socket.client.on("v-broadcast", this.handleVBroadcastMixin);
    },
    watch: {
        warningMessagePayment(val) {
            this.setIntervalChecking(Boolean(val));
        },
        isHasUsersChooseInvoice(val) {
            this.setIntervalChecking(Boolean(val));
        }
    },
    beforeDestroy() {
        this.$socket.client.off("v-broadcast", this.handleVBroadcastMixin);
        clearInterval(this.intervalId);
    },
    methods: {
        async joinPaymentInvoice(
            invoiceId,
            withAwait = !WITHAWAIT,
            isFromPaymentModal = !ISFROMPAYMENTMODAL
        ) {
            await this._getSetting();
            await this.$nextTick();

            // await this.$socket.client.on("connect"); // not working
            // problem which seem the v-broadcast not ready even here send the socket message and the the payment modal response a socket message, the v-broadcast still not capture the message
            if (withAwait) {
                await this._sleep(3000);
            }

            this.joinInvoiceId = invoiceId;
            this.isFromPaymentModal = isFromPaymentModal;
            this.emitSocketInvoiceJoin();
        },
        emitSocketInvoiceJoin() {
            // Emit socket to target the opened payment modal then the modal will emit socket if it select this invoice
            this.$socket.client.emit("v-broadcast", {
                action: "payment:invoice-join",
                invoiceId: this.joinInvoiceId,
                isFromPaymentModal: this.isFromPaymentModal,
                businessId: this.$root.setting.business_id,
                userName: this.$root.currentActor.fullname,
                userId: this.$root.currentActor.id
            });
        },
        handleVBroadcastMixin(payload) {
            if (payload.action == "payment:invoice-changed") {
                this.feedbackReceived = true;
            }
        },
        setIntervalChecking(allowIntervalTriggering) {
            if (allowIntervalTriggering) {
                this.intervalId = setInterval(() => {
                    this.feedbackReceived = false;
                    this.emitSocketInvoiceJoin(
                        this.joinInvoiceId,
                        this.isFromPaymentModal
                    );

                    setTimeout(() => {
                        if (!this.feedbackReceived) {
                            this.$store.commit(
                                "billing/setUsersChooseInvoice",
                                []
                            );
                            this.emitSocketInvoiceJoin(
                                this.joinInvoiceId,
                                this.isFromPaymentModal
                            );
                        }
                    }, 10000);
                }, 60000);
            } else {
                clearInterval(this.intervalId);
            }
        }
    }
};
